import styled, { css } from 'styled-components';
import {Colors, FlexBox} from "@brg/ui";
import { LayoutConst } from 'core';

interface IconWrapperProps {
  theme: any,
  disabled?: boolean;
  pressed?: boolean,
  hoverDisabled?: boolean,
  fullFill?: boolean;
  isSettings?: boolean;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  cursor: ${({ theme, hoverDisabled }) => hoverDisabled ? 'auto' : 'pointer'};
  & svg {
    path {
      fill: ${({ theme: { icon }, pressed, isSettings }) => pressed ? icon.active : isSettings ? Colors.galBlack47 : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme, hoverDisabled, isSettings }) => hoverDisabled ? (isSettings ? Colors.galBlack47 : theme.icon.default) : theme.icon.hover};
      }
    }

    :active {
      path {
        fill: ${({ theme, hoverDisabled, isSettings }) => hoverDisabled ? (isSettings ? Colors.galBlack47 : theme.icon.default) : theme.icon.active};
      }
    }
  }
  
  ${({isSettings, hoverDisabled, pressed, theme}) => isSettings && css`
    & svg {
      path {
        fill: ${pressed ? theme.icon.active : Colors.galBlack47}!important;
      }

      :hover {
        path {
          fill: ${hoverDisabled ? Colors.galBlack47 : theme.icon.hover}!important;
        }
      }

      :active {
        path {
          fill: ${hoverDisabled ? Colors.galBlack47 : theme.icon.active}!important;
        }
      }
    }
  `}
`

export const IconWrapperSpecial = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme }) => theme.icon.hoverSpecial};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.icon.activeSpecial};
      }
    }
  }

  ${(p) =>
        p.disabled
                ? css`
                  svg {
                  pointer-events: none;
                    fill: none !important;
                  }

                  cursor: default;
                `
                : null}

  ${p => p.pressed ? css`
  & svg {
    path {
      fill: ${({ theme }) => theme.icon.activeFillIconColor};
    }
    :hover {

      path {
        fill: ${({ theme }) => theme.icon.hoverSpecialActive};
      }
    }
  }
` : null}
`

export const DeadLineWarningWrapper = styled(FlexBox)`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: #FD6C52;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 16px;

  svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    white-space: break-spaces;

    span {
      white-space: break-spaces;
    }
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    width: 210px;
    max-width: 210px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    width: 100%;
    max-width: none;
    margin-top: 24px;
    // padding-right: 25px;
  }
`

export const IconWrapperSpecial2 = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    height: 32px;
    width: 32px;
    path {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }
    rect {
      stroke: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme, pressed }) => pressed ? theme.icon.activeSpecial : theme.icon.hover};
      }
      rect {
        stroke: ${({ theme, pressed }) => pressed ? theme.icon.activeSpecial : theme.icon.hover};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.icon.activeSpecial};
      }
      rect {
        stroke: ${({ theme }) => theme.icon.activeSpecial};
      }
    }
  }

  ${p => p.fullFill && p.pressed ? css`
    & svg {
      path {
        fill: ${({ theme }) => theme.icon.activeFillIconColor};
      }
      rect {
        stroke: ${({ theme }) => theme.icon.activeFillIconColor};
      }
      :hover {
        path {
          fill: ${({ theme }) => theme.icon.hoverSpecialActive};
        }
        rect {
          stroke: ${({ theme }) => theme.icon.hoverSpecialActive};
        }
      }
    }
  ` : null}
`

export const IconCompetitionSpecial = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme, pressed }) => pressed ? theme.competition.mainText : theme.competition.secondaryText}
    }

    :hover {
      path {
        fill: ${({ theme, pressed }) => pressed ? theme.competition.mainText : theme.competition.mainText};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.competition.mainText};
      }
    }
  }

  ${p => p.fullFill && p.pressed ? css`
    & svg {
      path {
        fill: ${({ theme }) => theme.competition.mainText};
      }
      :hover {
        path {
          fill: ${({ theme }) => theme.competition.mainText};
        }
      }
    }
  ` : null}
`

export const IconWrapperAdd = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme: { tags } }) => tags.borderColor}
    }

    :hover {
      path {
        fill: ${({ theme }) => theme.tags.borderColorHover};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.tags.borderColorActive};
      }
    }
  }
`import styled, { css } from 'styled-components';
import {Colors, FlexBox} from "@brg/ui";
import { LayoutConst } from 'core';

interface IconWrapperProps {
  theme: any,
  disabled?: boolean;
  pressed?: boolean,
  hoverDisabled?: boolean,
  fullFill?: boolean;
  isSettings?: boolean;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  cursor: ${({ theme, hoverDisabled }) => hoverDisabled ? 'auto' : 'pointer'};
  & svg {
    path {
      fill: ${({ theme: { icon }, pressed, isSettings }) => pressed ? icon.active : isSettings ? Colors.galBlack47 : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme, hoverDisabled, isSettings }) => hoverDisabled ? (isSettings ? Colors.galBlack47 : theme.icon.default) : theme.icon.hover};
      }
    }

    :active {
      path {
        fill: ${({ theme, hoverDisabled, isSettings }) => hoverDisabled ? (isSettings ? Colors.galBlack47 : theme.icon.default) : theme.icon.active};
      }
    }
  }
  
  ${({isSettings, hoverDisabled, pressed, theme}) => isSettings && css`
    & svg {
      path {
        fill: ${pressed ? theme.icon.active : Colors.galBlack47}!important;
      }

      :hover {
        path {
          fill: ${hoverDisabled ? Colors.galBlack47 : theme.icon.hover}!important;
        }
      }

      :active {
        path {
          fill: ${hoverDisabled ? Colors.galBlack47 : theme.icon.active}!important;
        }
      }
    }
  `}
`

export const IconWrapperSpecial = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme }) => theme.icon.hoverSpecial};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.icon.activeSpecial};
      }
    }
  }

  ${(p) =>
        p.disabled
                ? css`
                  svg {
                  pointer-events: none;
                    fill: none !important;
                  }

                  cursor: default;
                `
                : null}

  ${p => p.pressed ? css`
  & svg {
    path {
      fill: ${({ theme }) => theme.icon.activeFillIconColor};
    }
    :hover {

      path {
        fill: ${({ theme }) => theme.icon.hoverSpecialActive};
      }
    }
  }
` : null}
`

export const DeadLineWarningWrapper = styled(FlexBox)`
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: #FD6C52;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 16px;

  svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
    
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    white-space: break-spaces;

    span {
      white-space: break-spaces;
    }
  }

  @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    width: 210px;
    max-width: 210px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    width: 100%;
    max-width: none;
    margin-top: 24px;
    // padding-right: 25px;
  }
`

export const IconWrapperSpecial2 = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    height: 32px;
    width: 32px;
    path {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }
    rect {
      stroke: ${({ theme: { icon }, pressed }) => pressed ? icon.activeSpecial : icon.default}
    }

    :hover {
      path {
        fill: ${({ theme, pressed }) => pressed ? theme.icon.activeSpecial : theme.icon.hover};
      }
      rect {
        stroke: ${({ theme, pressed }) => pressed ? theme.icon.activeSpecial : theme.icon.hover};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.icon.activeSpecial};
      }
      rect {
        stroke: ${({ theme }) => theme.icon.activeSpecial};
      }
    }
  }

  ${p => p.fullFill && p.pressed ? css`
    & svg {
      path {
        fill: ${({ theme }) => theme.icon.activeFillIconColor};
      }
      rect {
        stroke: ${({ theme }) => theme.icon.activeFillIconColor};
      }
      :hover {
        path {
          fill: ${({ theme }) => theme.icon.hoverSpecialActive};
        }
        rect {
          stroke: ${({ theme }) => theme.icon.hoverSpecialActive};
        }
      }
    }
  ` : null}
`

export const IconCompetitionSpecial = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme, pressed }) => pressed ? theme.competition.mainText : theme.competition.secondaryText}
    }

    :hover {
      path {
        fill: ${({ theme, pressed }) => pressed ? theme.competition.mainText : theme.competition.mainText};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.competition.mainText};
      }
    }
  }

  ${p => p.fullFill && p.pressed ? css`
    & svg {
      path {
        fill: ${({ theme }) => theme.competition.mainText};
      }
      :hover {
        path {
          fill: ${({ theme }) => theme.competition.mainText};
        }
      }
    }
  ` : null}
`

export const IconWrapperAdd = styled.div<IconWrapperProps>`
  cursor: pointer;
  & svg {
    path {
      fill: ${({ theme: { tags } }) => tags.borderColor}
    }

    :hover {
      path {
        fill: ${({ theme }) => theme.tags.borderColorHover};
      }
    }

    :active {
      path {
        fill: ${({ theme }) => theme.tags.borderColorActive};
      }
    }
  }
`